/* tslint:disable */
/* eslint-disable */
/**
 * DUPR Backend APIs (Internal)
 * Internal RESTful APIs to access DUPR ratings, users and provide matches.
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../base';
// @ts-ignore
import type { BadgeDefinitionResponse } from '../../../commons/generated/model';
// @ts-ignore
import type { BadgeResponse } from '../../../commons/generated/model';
// @ts-ignore
import type { BadgeVisibilityRequest } from '../../../commons/generated/model';
// @ts-ignore
import type { UserActionRequiredResponse } from '../../../commons/generated/model';
/**
 * BadgesApi - axios parameter creator
 * @export
 */
export const BadgesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Resolves badge URNs to their display metadata. Omit `urns` to fetch the whole public catalog — it is small and this is the intended way to populate a client -side cache. A URN with no catalog entry is omitted from the response rather than erroring, matching the profile hydration path. System-hidden badges are never returned. Responds 304 when the supplied `If-None-Match` still matches.
         * @summary Look up badge definitions in bulk
         * @param {Array<string>} [urns] 
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBadgeDefinitions: async (urns?: Array<string>, ifNoneMatch?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/badges/definitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (urns) {
                localVarQueryParameter['urns'] = urns;
            }


    
            if (ifNoneMatch != null) {
                localVarHeaderParameter['If-None-Match'] = String(ifNoneMatch);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the effective-visible badges for the given (obfuscated) user id. When the caller is that user, hidden badges are included and flagged.
         * @summary Get a user\'s public badges
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBadgesForUser: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getBadgesForUser', 'userId', userId)
            const localVarPath = `/badges/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the caller\'s live badges. Hidden badges are included and flagged (`hidden = true`); this owner-view is the only place hidden badges are returned.
         * @summary Get the authenticated user\'s badges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyBadges: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/badges`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Adds/removes [urn] from the caller\'s hidden-badge blacklist, then best-effort re-syncs the ES projection. Returns the caller\'s updated owner-view badge list.
         * @summary Hide or unhide one of the authenticated user\'s badges
         * @param {string} urn 
         * @param {BadgeVisibilityRequest} badgeVisibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setBadgeVisibility: async (urn: string, badgeVisibilityRequest: BadgeVisibilityRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'urn' is not null or undefined
            assertParamExists('setBadgeVisibility', 'urn', urn)
            // verify required parameter 'badgeVisibilityRequest' is not null or undefined
            assertParamExists('setBadgeVisibility', 'badgeVisibilityRequest', badgeVisibilityRequest)
            const localVarPath = `/badges/{urn}/visibility`
                .replace(`{${"urn"}}`, encodeURIComponent(String(urn)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(badgeVisibilityRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BadgesApi - functional programming interface
 * @export
 */
export const BadgesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BadgesApiAxiosParamCreator(configuration)
    return {
        /**
         * Resolves badge URNs to their display metadata. Omit `urns` to fetch the whole public catalog — it is small and this is the intended way to populate a client -side cache. A URN with no catalog entry is omitted from the response rather than erroring, matching the profile hydration path. System-hidden badges are never returned. Responds 304 when the supplied `If-None-Match` still matches.
         * @summary Look up badge definitions in bulk
         * @param {Array<string>} [urns] 
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBadgeDefinitions(urns?: Array<string>, ifNoneMatch?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BadgeDefinitionResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBadgeDefinitions(urns, ifNoneMatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BadgesApi.getBadgeDefinitions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the effective-visible badges for the given (obfuscated) user id. When the caller is that user, hidden badges are included and flagged.
         * @summary Get a user\'s public badges
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getBadgesForUser(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BadgeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getBadgesForUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BadgesApi.getBadgesForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns the caller\'s live badges. Hidden badges are included and flagged (`hidden = true`); this owner-view is the only place hidden badges are returned.
         * @summary Get the authenticated user\'s badges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMyBadges(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BadgeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMyBadges(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BadgesApi.getMyBadges']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Adds/removes [urn] from the caller\'s hidden-badge blacklist, then best-effort re-syncs the ES projection. Returns the caller\'s updated owner-view badge list.
         * @summary Hide or unhide one of the authenticated user\'s badges
         * @param {string} urn 
         * @param {BadgeVisibilityRequest} badgeVisibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setBadgeVisibility(urn: string, badgeVisibilityRequest: BadgeVisibilityRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BadgeResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setBadgeVisibility(urn, badgeVisibilityRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['BadgesApi.setBadgeVisibility']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * BadgesApi - factory interface
 * @export
 */
export const BadgesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BadgesApiFp(configuration)
    return {
        /**
         * Resolves badge URNs to their display metadata. Omit `urns` to fetch the whole public catalog — it is small and this is the intended way to populate a client -side cache. A URN with no catalog entry is omitted from the response rather than erroring, matching the profile hydration path. System-hidden badges are never returned. Responds 304 when the supplied `If-None-Match` still matches.
         * @summary Look up badge definitions in bulk
         * @param {Array<string>} [urns] 
         * @param {string} [ifNoneMatch] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBadgeDefinitions(urns?: Array<string>, ifNoneMatch?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BadgeDefinitionResponse>> {
            return localVarFp.getBadgeDefinitions(urns, ifNoneMatch, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the effective-visible badges for the given (obfuscated) user id. When the caller is that user, hidden badges are included and flagged.
         * @summary Get a user\'s public badges
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getBadgesForUser(userId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<BadgeResponse>> {
            return localVarFp.getBadgesForUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the caller\'s live badges. Hidden badges are included and flagged (`hidden = true`); this owner-view is the only place hidden badges are returned.
         * @summary Get the authenticated user\'s badges
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMyBadges(options?: RawAxiosRequestConfig): AxiosPromise<Array<BadgeResponse>> {
            return localVarFp.getMyBadges(options).then((request) => request(axios, basePath));
        },
        /**
         * Adds/removes [urn] from the caller\'s hidden-badge blacklist, then best-effort re-syncs the ES projection. Returns the caller\'s updated owner-view badge list.
         * @summary Hide or unhide one of the authenticated user\'s badges
         * @param {string} urn 
         * @param {BadgeVisibilityRequest} badgeVisibilityRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setBadgeVisibility(urn: string, badgeVisibilityRequest: BadgeVisibilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<BadgeResponse>> {
            return localVarFp.setBadgeVisibility(urn, badgeVisibilityRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BadgesApi - interface
 * @export
 * @interface BadgesApi
 */
export interface BadgesApiInterface {
    /**
     * Resolves badge URNs to their display metadata. Omit `urns` to fetch the whole public catalog — it is small and this is the intended way to populate a client -side cache. A URN with no catalog entry is omitted from the response rather than erroring, matching the profile hydration path. System-hidden badges are never returned. Responds 304 when the supplied `If-None-Match` still matches.
     * @summary Look up badge definitions in bulk
     * @param {Array<string>} [urns] 
     * @param {string} [ifNoneMatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BadgesApiInterface
     */
    getBadgeDefinitions(urns?: Array<string>, ifNoneMatch?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<BadgeDefinitionResponse>>;

    /**
     * Returns the effective-visible badges for the given (obfuscated) user id. When the caller is that user, hidden badges are included and flagged.
     * @summary Get a user\'s public badges
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BadgesApiInterface
     */
    getBadgesForUser(userId: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<BadgeResponse>>;

    /**
     * Returns the caller\'s live badges. Hidden badges are included and flagged (`hidden = true`); this owner-view is the only place hidden badges are returned.
     * @summary Get the authenticated user\'s badges
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BadgesApiInterface
     */
    getMyBadges(options?: RawAxiosRequestConfig): AxiosPromise<Array<BadgeResponse>>;

    /**
     * Adds/removes [urn] from the caller\'s hidden-badge blacklist, then best-effort re-syncs the ES projection. Returns the caller\'s updated owner-view badge list.
     * @summary Hide or unhide one of the authenticated user\'s badges
     * @param {string} urn 
     * @param {BadgeVisibilityRequest} badgeVisibilityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BadgesApiInterface
     */
    setBadgeVisibility(urn: string, badgeVisibilityRequest: BadgeVisibilityRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<BadgeResponse>>;

}

/**
 * BadgesApi - object-oriented interface
 * @export
 * @class BadgesApi
 * @extends {BaseAPI}
 */
export class BadgesApi extends BaseAPI implements BadgesApiInterface {
    /**
     * Resolves badge URNs to their display metadata. Omit `urns` to fetch the whole public catalog — it is small and this is the intended way to populate a client -side cache. A URN with no catalog entry is omitted from the response rather than erroring, matching the profile hydration path. System-hidden badges are never returned. Responds 304 when the supplied `If-None-Match` still matches.
     * @summary Look up badge definitions in bulk
     * @param {Array<string>} [urns] 
     * @param {string} [ifNoneMatch] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BadgesApi
     */
    public getBadgeDefinitions(urns?: Array<string>, ifNoneMatch?: string, options?: RawAxiosRequestConfig) {
        return BadgesApiFp(this.configuration).getBadgeDefinitions(urns, ifNoneMatch, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the effective-visible badges for the given (obfuscated) user id. When the caller is that user, hidden badges are included and flagged.
     * @summary Get a user\'s public badges
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BadgesApi
     */
    public getBadgesForUser(userId: number, options?: RawAxiosRequestConfig) {
        return BadgesApiFp(this.configuration).getBadgesForUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the caller\'s live badges. Hidden badges are included and flagged (`hidden = true`); this owner-view is the only place hidden badges are returned.
     * @summary Get the authenticated user\'s badges
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BadgesApi
     */
    public getMyBadges(options?: RawAxiosRequestConfig) {
        return BadgesApiFp(this.configuration).getMyBadges(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Adds/removes [urn] from the caller\'s hidden-badge blacklist, then best-effort re-syncs the ES projection. Returns the caller\'s updated owner-view badge list.
     * @summary Hide or unhide one of the authenticated user\'s badges
     * @param {string} urn 
     * @param {BadgeVisibilityRequest} badgeVisibilityRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BadgesApi
     */
    public setBadgeVisibility(urn: string, badgeVisibilityRequest: BadgeVisibilityRequest, options?: RawAxiosRequestConfig) {
        return BadgesApiFp(this.configuration).setBadgeVisibility(urn, badgeVisibilityRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

